import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class InversionistasGruposService {

  private service_url: string;

  constructor( private http: Http,
               private constantsServices: ConstantsService,
               private validatorService: ValidatorService,
               private errorService: ErrorsService,
               private authService: AutenticacionService) {
      this.service_url = constantsServices.apiURL + '/inversionistas/grupos';
  }

  public getDefaultSchedule() {
    return {
      'idInversionistas_Grupos': '',
      'nombre': '',
      'rfc': '',
      'telefono': '',
      'email': '',
      'inversionistas_elementos': []
    };
  }

  public createInversionistasGrupo(data) {
      data = this.refactor(data);
      return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public updateInversionistasGrupo(data, id) {
    data = this.refactor(data);
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  public searchInversionistasGrupos(text, page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&search=' + text + '&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true&search=' + text, this.authService.getAuthHeaders());
  }

  public deleteInversionistasGrupo(id) {
    return this.http.delete(this.service_url + '?id=' + id, this.authService.getAuthHeaders());
  }

  public getInversionistasGrupos(page = null) {

    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }

  public getInversionistasGruposList() {
    return this.http.get(this.service_url, this.authService.getAuthHeaders());
  }

  public refactor(data) {
    data.inversionistas_elementos.forEach(element => {
      if (element.inversionistas.idInversionistas) {
        element.idInversionistas = element.inversionistas.idInversionistas;
      }
    });

    return data;
  }

  public writePermission() {
    return this.authService.hasPermission(6, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public export(search) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.service_url + '/exportar?search='+search, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

  public validateInversionistaGrupo(data) {
    console.log('validating...', data);
    let error = [];


    // validacion de NOMBRE
    if (!this.validatorService.required(data['nombre'])) {
      error['nombre'] = this.errorService.required;
    } else if (!this.validatorService.max(data['nombre'], 50)) {
      error['nombre'] = this.errorService.max(50);
    }

    // validacion de RFC
    if (!this.validatorService.required(data['rfc'])) {
      error['rfc'] = this.errorService.required;
    } else if (!this.validatorService.max(data['rfc'], 15)) {
      error['rfc'] = this.errorService.max(15);
    }

    // validacion de EMAIL
    if (!this.validatorService.required(data['email'])) {
      error['email'] = this.errorService.required;
    } else if (!this.validatorService.max(data['email'], 40)) {
      error['email'] = this.errorService.max(40);
    } else if (!this.validatorService.email(data['email'])) {
      error['email'] = this.errorService.email;
    }

    // validacion de TELEFONO
    if (!this.validatorService.required(data['telefono'])) {
      error['telefono'] = this.errorService.required;
    } else if (!this.validatorService.max(data['telefono'], 30)) {
      error['telefono'] = this.errorService.max(30);
    }

    // validacion de INVERSIONISTAS
    if (!this.validatorService.required(data['inversionistas_elementos'])) {
      error['inversionistas_elementos'] = this.errorService.required;
    }

    return error;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/inversionistas-grupos.service.ts